import { defineComponent as _defineComponent } from 'vue'
import { Personalisation, PersonalisationDisplayDetails } from 'ctp-personalisation-search';
import { computed, onMounted, PropType, ref } from 'vue';
import useStore from '@/utils/store/common';
import RawData from './components/RawData/RawData.vue';
import DeviceAssociation from './components/DeviceAssociation/DeviceAssociation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalisationDetails',
  props: {
  enabled: {
    type: Boolean,
    default: false
  },
  perso: {
    type: Object as PropType<Personalisation>,
    default: () => ({})
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;





const store = useStore();

const persoDetails = ref({} as PersonalisationDisplayDetails);

const showRaw = ref(false);

const display = computed(() => props.enabled);

onMounted(async () => {
  const payload = {
    type: props.perso.type,
    id: props.perso.deviceId,
    masterId: props.perso.masterId,
    version: props.perso.version
  };
  await store.dispatch('personalisation/fetchPersonalisationDetails', payload);
  persoDetails.value = store.getters['personalisation/getPersonalisationDetails'][props.perso.deviceId];
});

function handleClose() {
  emit('close', {});
}

function setShowRawData(value: boolean) {
  showRaw.value = value;
}

return { __sfc: true,props, emit, store, persoDetails, showRaw, display, handleClose, setShowRawData, RawData, DeviceAssociation }
}

})